<div class="w-full max-w-2xl mx-auto border border-gray-200 rounded-lg">
    <ng-content></ng-content>
</div>